import type { ISyncService } from '@core/modules/sync/application/syncService/types';

export class SyncService implements ISyncService {}
